import {CreateOrderForm} from "./viewmodel";

export function init(options) {
	const $wrapper = $('#createOrderWrap');
	const $inputLink = $wrapper.find('.formProcessLink [name=order_id]');

	const model = initModel($wrapper, options);

	model.onSuccess.add(() => {
		const top = $wrapper.offset().top;
		$('body,html').animate({scrollTop: top}, 600);
		$inputLink.val('');
	});
}

export function initModel($wrapper, options) {
	$wrapper = $($wrapper);
	const $formProcess = $wrapper.find('.formProcessLink');
	const $formOrder = $wrapper.find('.formOrder');
	const $formOrderInfo = $wrapper.find('.formOrderInfo');
	const model = new CreateOrderForm($formOrder, options);
	const $inputLink = $formProcess.find('[name=order_id]');

	ko.applyBindings(model, $formOrder[0]);
	if($formOrderInfo.length) {
        ko.applyBindings(model, $formOrderInfo[0]);
    }

	$formProcess.validate({
		onfocusout: false,
		submitHandler: () => {
			processLink();
		}
	});

	$inputLink
		.on('focusin', function () {
			this.select();
		})
		.on('paste', function () {
			setTimeout(() => $formProcess.submit(), 1);
		});

	if ($inputLink.val()) {
		// options may contain orderData, so no need to submit
		if (!model.isLoaded()) {
			$formProcess.submit();
		}
	} else {
		$inputLink.focus();
	}

	return model;

	function processLink() {
		const link = $.trim($inputLink.val());
		if (link) {
			return model.process(link);
		}
		return false;
	}
}



// WEBPACK FOOTER //
// ./modules/packages/create_order/index.js